// extracted by mini-css-extract-plugin
module.exports = {"gradientOutline":"style-module__gradientOutline___3u_BL","scoreReportLink":"style-module__scoreReportLink___3WSlh"};